import { useQuery } from 'react-query';

import api from '@root/api/newApi';

function useProducts(
  {
    collectionId,
    productStatuses,
    limit,
  } = { collectionId: null, productStatuses: null, limit: false },
) {
  return useQuery(
    ['shopify-products', collectionId, productStatuses, limit],
    () => api.shopify.getProducts({
      ...(collectionId && { collectionId }),
      ...(productStatuses && { productStatuses: productStatuses.join(',') }),
      limit,
    }),
  );
}

export default useProducts;
